import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=7cb287da&scoped=true"
import script from "@/views/Settings/Suppliers/Suppliers.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Suppliers/Suppliers.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Suppliers/suppliers.scss?vue&type=style&index=0&id=7cb287da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb287da",
  null
  
)

export default component.exports